import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import { ThemedButton } from "@/App/components";
import { StackOrShelf } from "@/App/components/StackOrShelf";
import { formatPhoneNumber } from "@/App/utils/utils";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.providerDetails";

export interface ProviderDetails {
  readonly npi: string;
  readonly name: string;
  readonly addressLine1: string;
  readonly addressLine2: string;
  readonly city: string;
  readonly state: string;
  readonly zip: string;
  readonly phone: string;
}

interface ProviderCard {
  readonly provider: ProviderDetails;
  readonly isSelected?: boolean;
  readonly setSelectedProvider: React.Dispatch<React.SetStateAction<ProviderDetails | null>>;
}

export const DirectMemberReimbursementProviderDetailsCard = ({ provider, isSelected = false, setSelectedProvider }: ProviderCard) => {
  const { t: translate } = useTranslation();

  const providerCityStateZip = useMemo(() => {
    let addr = "";
    if (provider?.city?.length > 0) {
      addr += provider.city + ", ";
    }
    if (provider?.state?.length > 0) {
      addr += provider?.state;
    }
    if (provider?.zip?.length > 0) {
      if (addr.length > 0) {
        addr += " ";
      }
      addr += provider?.zip;
    }
    return addr;
  }, [provider]);

  const onClickProviderCard = () => {
    if (isSelected) {
      setSelectedProvider(null);
    } else {
      setSelectedProvider(provider);
    }
  };

  return (
    <Panel style={{ borderRadius: "8px" }} appearance="primary">
      <StackOrShelf spacing="medium">
        <Stack alignment="left" spacing="small">
          <Shelf alignment="top">
            <Stack alignment="left" spacing="none">
              <Body style={{ color: "#60646D" }}>
                <Semibold>
                  {translate(`${TRANSLATION_PATH}.npi`)}: {provider?.npi}
                </Semibold>
              </Body>
              <Body>
                <Semibold>{provider?.name}</Semibold>
              </Body>
            </Stack>
          </Shelf>
          <Stack.Spacer />
          <Shelf alignment="top">
            <Stack alignment="left" spacing="none">
              {provider?.addressLine1 && <Body>{provider?.addressLine1}</Body>}
              {provider?.addressLine2 && <Body>{provider?.addressLine2}</Body>}
              {providerCityStateZip && <Body>{providerCityStateZip}</Body>}
              {provider?.phone && <Body>{formatPhoneNumber(provider?.phone)}</Body>}
            </Stack>
          </Shelf>
        </Stack>
        <Shelf.Spacer />
        <ThemedButton onClick={onClickProviderCard} appearance="secondary">
          {isSelected && translate(`${TRANSLATION_PATH}.change`)}
          {!isSelected && translate(`${TRANSLATION_PATH}.select`)}
        </ThemedButton>
      </StackOrShelf>
    </Panel>
  );
};
